// Modules
import React, { useEffect } from 'react'
import { Intent, Toast, Toaster } from '@blueprintjs/core'
import PropTypes from 'prop-types'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'
import useNotices from 'hooks/system/useNotices'

// Constants
import { INTENT_ICON_MAPPING } from 'constants/generic'

// Styles
import './Notice.scss'

// Data (Local)
const noticeTypeIntentMapping = { error: Intent.DANGER, information: Intent.PRIMARY, success: Intent.SUCCESS, warning: Intent.WARNING }

// Component: Utility > Notice
function Notice ({ className, style }) {
	// Data
	const { notices, removeNotice } = useNotices()
	// const { translate } = useLanguage('components.utility.notice')

	// Functions
	function getIntent (type) {
		return noticeTypeIntentMapping[type || 'information']
	}

	// Effects
	useEffect(() => {
		let timer
		if (notices?.length > 0) {
			const noticesToRemoveAutomatically = notices
				.filter(notice => !notice.willPersist)
				.map(notice => notice.id)
			if (noticesToRemoveAutomatically.length > 0) {
				timer = setTimeout(() => removeNotice(noticesToRemoveAutomatically), 10000)
			}
		}
		return () => clearTimeout(timer)
	}, [notices, removeNotice])

	// Render
	if (!(notices?.length > 0)) return null
	return (
		<div
			id="notice"
			data-utility="notice"
			className={className}
			style={style}>
			<Toaster
				usePortal
				position="top"
				className="aix-notices"
				canEscapeKeyClear={false}>
				{notices.map(notice =>
					<Toast
						key={notice.id}
						message={notice.message}
						className="aix-notice"
						intent={getIntent(notice.type)}
						icon={notice.icon || INTENT_ICON_MAPPING[noticeTypeIntentMapping[notice.type]]}
						onDismiss={() => removeNotice(notice.id)}
						timeout={0}
						action={
							notice.action
								? {
									className: 'aix-notice-action',
									intent: getIntent(notice.type),
									onClick: () => {
										if (!!notice.action.onClick) notice.action.onClick()
										removeNotice(notice.id)
									},
									text: notice.action.text
								}
								: null
						} />
				)}
			</Toaster>
		</div>
	)
}

// Properties
Notice.propTypes = {
	className: PropTypes.string,
	style: PropTypes.object
}

// Export
export default Notice
